import script from "./IconButton.vue?vue&type=script&setup=true&lang=js"
export * from "./IconButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/app/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"IconButton.vue"]])

export default __exports__